import React, { useEffect } from "react";
import { NavHashLink } from 'react-router-hash-link';
import ReturnImage from "../functions/image";

const Pagebanner = () => {
    useEffect(() => {
        document.querySelector(".pagebanner-button").classList.remove("active");
    }, []);

    return (
        <div className="pagebanner container-fluid text-white" style={ { padding: 0 } }>
            <div className="d-flex flex-column align-items-center justify-content-center pagebanner-container">
                <div className="pagebanner-title text-center">
                    <h1 className="pagebanner-title-animate text-center">Dev WordPress. Dev React.</h1>
                    <span>Dev mentalement instable ? Peut-être</span>
                </div>
                <NavHashLink to="#about" className="btn btn-primary pagebanner-button">Ca se passe par là !</NavHashLink>
                <ReturnImage
                 imageName="mustafa-suisse"
                 classname="pagebanner-image"
                 alt="Développez vos projets avec Mustafa Ekiz"
                 viewport={100} />
            </div>
        </div>
    )
};

export default Pagebanner;